<template>
  <div class="cf-page" :class="{'is-lock': !canEdit, 'is-embed': embedded}">
    <div class="cf-app">
      <div v-if="loaded && blockTip" class="rater">{{ blockTip }}</div>
      <div v-else-if="loaded && !canEdit" class="rater">评分人：{{ raterName }}</div>

      <div class="rate">
        <div class="q">本节课整体表现，打几星？</div>
        <div class="sub">1 星最低，5 星最高；打完星自动匹配该星级对应的课堂表现</div>
        <div class="bigstars">
          <span
            v-for="n in 5"
            :key="n"
            class="s"
            :class="{on: star >= n}"
            @click="setStar(n)"
          >★</span>
        </div>
        <div class="rate-read">
          <span v-if="!star" class="hint">点击星星打分</span>
          <template v-else>
            <span class="emo">{{ face }}</span>
            <span>
              <span class="txt">{{ rateStarText }}</span>
              <span class="hint">　{{ star }} 星 · {{ faceTxt }}</span>
            </span>
          </template>
        </div>

        <div class="sug" :class="{show: star > 0}">
          <div class="cap"><b>该星级对应的课堂表现</b>（勾选符合的项，可多选）：</div>
          <div class="taglist">
            <div
              v-for="o in recList"
              :key="o.id"
              class="tag"
              :class="{sel: isPicked(o.id)}"
              @click="toggle(o.id)"
            >
              <div class="t">{{ o.text }}</div>
              <div class="d">{{ o.dim }}</div>
            </div>
          </div>
          <div class="sugbtns">
            <button class="mini strong" type="button" @click="refresh">换一换</button>
            <button class="mini" type="button" @click="toggleLib">{{ libBtnText }}</button>
          </div>
          <div class="lib" :class="{show: libOpen}">
            <input
              class="search"
              v-model="libKw"
              placeholder="搜索关键词，如：纠音、口音、开口、迟到"
            >
            <div v-if="star">
              <div v-if="libList.length" class="grp">
                <h4><span class="n">{{ star }}星</span> {{ faceTxt }}　{{ libList.length }} 项{{ libSuffix }}</h4>
                <div class="taglist">
                  <div
                    v-for="o in libList"
                    :key="o.id"
                    class="tag"
                    :class="{sel: isPicked(o.id)}"
                    @click="toggle(o.id)"
                  >
                    <div class="t">{{ o.text }}</div>
                    <div class="d">{{ o.dim }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="lib-empty">该星级下没有匹配的选项</div>
            </div>
          </div>
        </div>
      </div>

      <div class="picked" :class="{show: pickedIds.length > 0}">
        <div class="hd">已选表现 <span>{{ pickCountText }}</span></div>
        <div class="chips">
          <div
            v-for="o in pickedItems"
            :key="o.id"
            class="chip"
            @click="removePicked(o.id)"
          >{{ o.text }} <i>· {{ o.dim }} · {{ o.star }}星</i></div>
        </div>
        <div v-show="conflictText" class="conflict">{{ conflictText }}</div>
      </div>

      <div class="redcard" :class="{on: redCodes.length > 0}">
        <div class="rt">红线库（一票否决）</div>
        <div class="rd">勾选任一红线项 → 本次直接判 1 星；外教可在 7 日内申请复听重评</div>
        <div
          v-for="item in redList"
          :key="item.code"
          class="ritem"
          :class="{sel: isRed(item.code)}"
          @click="toggleRed(item.code)"
        >
          <span class="ck"></span>
          <span class="rl-t">{{ item.title }}</span>
          <span class="rl-d">{{ item.desc }}</span>
        </div>
      </div>

      <div class="summary">
        <div class="row">
          <div>
            <div class="sum-label">综合评分</div>
            <div class="score"><span>{{ scoreText }}</span><small> / 5.00</small></div>
          </div>
          <div class="sum-right">
            <div class="big">{{ summaryStars }}</div>
            <div class="grade">{{ gradeText }}</div>
          </div>
        </div>
        <div v-show="adviceText" class="advice">{{ adviceText }}</div>
        <div v-show="redWarn" class="warn">{{ redWarn }}</div>
      </div>

      <div class="card note">
        <h2>补充说明（可选）</h2>
        <textarea
          v-model="note"
          maxlength="500"
          :readonly="!canEdit"
          placeholder="我还有话说…（典型问题、亮点行为、建议复查时间）"
        ></textarea>
        <div class="cnt"><span>{{ note.length }}</span>/500</div>
      </div>

      <button v-if="canEdit" class="save" type="button" @click="save">保存</button>
    </div>
  </div>
</template>

<script>
const RAW = {
  '上课准备与讲解': [
    ['无备课痕迹', '课件不熟或选错进度', '讲解混乱', '大量中文', '环节严重缺失'],
    ['照读课件', '内容不熟悉', '中文偏多', '讲解粗浅'],
    ['内容一般', '目标笼统', '讲解平淡', '中文解释较多'],
    ['内容较熟练', '目标清晰', '环节较完整', '讲解较细致', '少量中文辅助'],
    ['备课充分', '目标清晰', '上课环节完整', '内容熟练', '课件操作无误', '讲解细致', '全英文授课']
  ],
  '语言输入质量': [
    ['严重口音', '语音含混难懂', '语法错误较多', '大量中文'],
    ['口音较重', '语速失控', '指令听不懂', '依赖中文解释'],
    ['稍有口音', '语速偏快', '指令偶需重复', '轻微用词不当'],
    ['发音基本标准', '偶有口音', '语速较适配', '指令清楚有示范'],
    ['语音标准流畅', '语速适配学生水平', '指令简短易懂', '善用 TPR 与动作', '示范准确', '全英文授课']
  ],
  '互动与学生开口': [
    ['教师单向灌输', '学生几乎不开口 占比＜20%', '不给表达机会'],
    ['学生开口少 占比 20–30%', '提问封闭', '频繁打断', '替学生说完'],
    ['学生开口一般 占比 30–40%', '以跟读和是非问答为主', '等待时间偏短', '缺少追问'],
    ['学生开口较多 占比 40–50%', '半开放式提问', '有追问', '等待时间基本足够'],
    ['学生开口充分 占比≥50%', '开放式提问', '追问扩展充分', '等待 3–5 秒', '不抢答不代答']
  ],
  '纠错与反馈': [
    ['完全没有纠音', '错误放任不管', '无正向激励', '无课后反馈'],
    ['基本没纠音', '纠错生硬', '学生退缩', '同类错误反复出现'],
    ['偶有纠音', '只纠明显错误', '直接给答案', '表扬笼统'],
    ['有纠音但不详细', '偶有遗漏', '示范+重复为主', '表扬偏泛'],
    ['纠音详细及时', '循循善诱', '引导自我修正', '给重试机会', '表扬具体', '课末明确下一步练习']
  ],
  '课堂氛围与控时': [
    ['冷漠不耐烦', '斥责学生', '严重拖堂或提前结束', '环节严重缺失'],
    ['氛围沉闷', '缺乏眼神交流', '控时前松后紧', '学生走神无干预'],
    ['态度友好但平淡', '控时偏差 3–5 分钟', '走神靠口头提醒'],
    ['亲和有能量', '氛围良好', '控时偏差≤2 分钟', '学生投入'],
    ['情绪饱满', '亲和耐心有感染力', '控时得当', '趣味引导拉回走神', '全程无斥责']
  ],
  '出勤与设备形象': [
    ['缺课或迟到＞5 分钟', '网络频繁卡顿掉线', '长时间关摄像头', '仪表不正'],
    ['迟到 3–5 分钟', '网络不畅影响教学', '摄像头多次关闭', '背景不整洁'],
    ['迟到 1–3 分钟', '网络偶有延迟', '短暂关摄像头', '仪表基本得体'],
    ['踩点到课未测设备', '网络良好', '偶有关摄像头', '仪表整洁'],
    ['提前 3–5 分钟到课', '网络流畅音视频清晰', '摄像头全程开启', '仪表整洁背景专业']
  ]
}

function buildPool () {
  let pool = []
  Object.keys(RAW).forEach(function (dim) {
    RAW[dim].forEach(function (arr, si) {
      arr.forEach(function (text) {
        pool.push({
          dim: dim,
          star: si + 1,
          text: text,
          id: dim + '|' + (si + 1) + '|' + text
        })
      })
    })
  })
  return pool
}

function shuffle (a) {
  for (let i = a.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let tmp = a[i]
    a[i] = a[j]
    a[j] = tmp
  }
  return a
}

const POOL = buildPool()
const FACES = ['😞', '😕', '😐', '🙂', '🤩']
const FACE_TXT = ['不合格', '待改进', '合格', '良好', '优秀']
const GRADES = [
  {min: 5, stars: 5, label: '★★★★★ 优秀', advice: '处置：优先排课 / 课时费上浮 / 示范课候选'},
  {min: 4, stars: 4, label: '★★★★ 良好', advice: '处置：正常排课，正常激励'},
  {min: 3, stars: 3, label: '★★★ 合格', advice: '处置：正常排课 + 指定 1 项改进点'},
  {min: 2, stars: 2, label: '★★ 待改进', advice: '处置：1v1 反馈 + 指定改进点 + 30 天复查'},
  {min: 1, stars: 1, label: '★ 不合格', advice: '处置：暂停排课 + PIP 改进计划（30 天，≥2 次复听）'}
]
const RED_LIST = [
  {code: 'R1', title: '态度粗鲁', desc: '冷漠敷衍、不耐烦、呵斥学生'},
  {code: 'R2', title: '言辞不当', desc: '不当玩笑、不当用语、语气伤人'},
  {code: 'R3', title: '羞辱学生', desc: '嘲讽、贬低、负面比较（如“你太笨了”）'},
  {code: 'R4', title: '歧视言论', desc: '涉及国籍、种族、外貌、性别的歧视性言论'},
  {code: 'R5', title: '敏感话题', desc: '涉及政治、宗教、色情、暴力的内容或引导讨论'}
]
const RED_MAP = {
  R1: '态度粗鲁',
  R2: '言辞不当',
  R3: '羞辱学生',
  R4: '歧视言论',
  R5: '敏感话题'
}

export default {
  props: {
    lessonOpenedId: { type: [String, Number], default: '' },
    embedded: { type: Boolean, default: false }
  },
  data () {
    return {
      openedId: '',
      loaded: false,
      canEdit: false,
      blockTip: '',
      raterName: '',
      star: 0,
      pickedIds: [],
      redCodes: [],
      note: '',
      recList: [],
      libOpen: false,
      libKw: '',
      saving: false,
      redList: RED_LIST
    }
  },
  computed: {
    face () {
      if (!this.star) return ''
      return FACES[this.star - 1]
    },
    faceTxt () {
      if (!this.star) return ''
      return FACE_TXT[this.star - 1]
    },
    rateStarText () {
      if (!this.star) return ''
      return '★'.repeat(this.star) + '☆'.repeat(5 - this.star)
    },
    finalStar () {
      if (!this.star) return 0
      if (this.redCodes.length) return 1
      return this.star
    },
    gradeItem () {
      let s = this.finalStar
      if (!s) return null
      return GRADES.find(function (x) {
        return s >= x.min
      }) || null
    },
    scoreText () {
      if (!this.star) return '—'
      return this.finalStar.toFixed(2)
    },
    summaryStars () {
      if (!this.star) return '☆☆☆☆☆'
      return '★'.repeat(this.finalStar) + '☆'.repeat(5 - this.finalStar)
    },
    gradeText () {
      if (!this.star) return '待评分'
      if (this.redCodes.length) return '★ 不合格（红线）'
      return this.gradeItem ? this.gradeItem.label : ''
    },
    adviceText () {
      if (!this.star) return '打星后自动计算'
      if (this.redCodes.length) return ''
      return this.gradeItem ? this.gradeItem.advice : ''
    },
    redNames () {
      return this.redCodes.map(function (code) {
        return RED_MAP[code]
      }).filter(function (name) {
        return !!name
      })
    },
    redWarn () {
      if (!this.redCodes.length) return ''
      return '红线已触发（' + this.redNames.join('、') + '）：本次直接判 1 星。'
    },
    starTotal () {
      let star = this.star
      if (!star) return 0
      return POOL.filter(function (o) {
        return o.star === star
      }).length
    },
    libBtnText () {
      if (!this.star) return '该星级全部选项'
      return '该星级全部选项（' + this.star + '星 · ' + this.starTotal + '项）'
    },
    libKwTrim () {
      return (this.libKw || '').trim()
    },
    libSuffix () {
      if (!this.libKwTrim) return '（该星级全部选项）'
      return '（已按「' + this.libKwTrim + '」过滤，共 ' + this.starTotal + ' 项）'
    },
    libList () {
      let star = this.star
      if (!star) return []
      let kw = this.libKwTrim
      return POOL.filter(function (o) {
        return o.star === star && (!kw || o.text.indexOf(kw) !== -1 || o.dim.indexOf(kw) !== -1)
      })
    },
    pickedItems () {
      let ids = this.pickedIds
      return POOL.filter(function (o) {
        return ids.indexOf(o.id) !== -1
      })
    },
    pickCountText () {
      return '共 ' + this.pickedIds.length + ' 项（点击可移除）'
    },
    conflictText () {
      let ids = this.pickedIds
      let dimStars = {}
      POOL.forEach(function (o) {
        if (ids.indexOf(o.id) === -1) return
        if (!dimStars[o.dim]) dimStars[o.dim] = {}
        dimStars[o.dim][o.star] = true
      })
      let bad = Object.keys(dimStars).filter(function (dim) {
        return Object.keys(dimStars[dim]).length > 1
      })
      if (!bad.length) return ''
      return '注意：' + bad.join('、') + ' 同时选了不同档位的表现，请核对后再提交。'
    }
  },
  mounted () {
    this.openedId = this.lessonOpenedId || (this.$route.query && this.$route.query.openedId) || ''
    this.load()
  },
  methods: {
    load () {
      if (!this.openedId) return
      let self = this
      this.$http.get('/bookLesson/classFeedback/detail', {params: {openedId: this.openedId}}).then(function (res) {
        if (!res || res.status !== 'ok') return
        let d = res.data || {}
        self.loaded = true
        self.canEdit = !!d.canEdit
        self.blockTip = d.blockTip || ''
        self.raterName = d.raterName || ''
        self.note = d.note || ''
        self.pickedIds = self.parsePicked(d.pickedIds)
        self.redCodes = self.parseReds(d.redCodes)
        let n = parseInt(d.star, 10)
        if (n >= 1 && n <= 5) {
          self.applyStar(n)
        }
      })
    },
    parsePicked (raw) {
      if (!raw) return []
      let arr = raw
      if (typeof raw === 'string') {
        try {
          arr = JSON.parse(raw)
        } catch (e) {
          return []
        }
      }
      if (!Array.isArray(arr)) return []
      return arr.filter(function (id) {
        return typeof id === 'string' && id
      })
    },
    parseReds (raw) {
      if (!raw) return []
      return String(raw).split(',').map(function (s) {
        return s.trim()
      }).filter(function (code) {
        return !!RED_MAP[code]
      })
    },
    applyStar (n) {
      this.star = n
      this.refresh()
    },
    setStar (n) {
      if (!this.canEdit) return
      this.applyStar(n)
    },
    refresh () {
      if (!this.star) return
      let star = this.star
      let pool = POOL.filter(function (o) {
        return o.star === star
      })
      let byDim = {}
      pool.forEach(function (o) {
        if (!byDim[o.dim]) {
          byDim[o.dim] = []
        }
        byDim[o.dim].push(o)
      })
      let picks = Object.keys(byDim).map(function (dim) {
        let list = byDim[dim]
        return list[Math.floor(Math.random() * list.length)]
      })
      let chosen = {}
      picks.forEach(function (o) {
        chosen[o.id] = true
      })
      let rest = shuffle(pool.filter(function (o) {
        return !chosen[o.id]
      }))
      let extra = Math.floor(Math.random() * 3)
      this.recList = shuffle(picks.concat(rest.slice(0, extra)))
    },
    isPicked (id) {
      return this.pickedIds.indexOf(id) !== -1
    },
    toggle (id) {
      if (!this.canEdit) return
      let i = this.pickedIds.indexOf(id)
      if (i >= 0) {
        this.pickedIds.splice(i, 1)
      } else {
        this.pickedIds.push(id)
      }
    },
    removePicked (id) {
      if (!this.canEdit) return
      let i = this.pickedIds.indexOf(id)
      if (i >= 0) {
        this.pickedIds.splice(i, 1)
      }
    },
    toggleLib () {
      this.libOpen = !this.libOpen
    },
    isRed (code) {
      return this.redCodes.indexOf(code) !== -1
    },
    toggleRed (code) {
      if (!this.canEdit) return
      let i = this.redCodes.indexOf(code)
      if (i >= 0) {
        this.redCodes.splice(i, 1)
      } else {
        this.redCodes.push(code)
      }
    },
    save () {
      if (!this.canEdit || this.saving) return
      if (!(this.star >= 1 && this.star <= 5)) {
        this.$Message.warning('请先打星')
        return
      }
      let self = this
      this.saving = true
      this.$http.post('/bookLesson/classFeedback/save', {
        openedId: this.openedId,
        star: this.star,
        redCodes: this.redCodes.join(','),
        pickedIds: JSON.stringify(this.pickedIds),
        note: this.note || ''
      }).then(function (res) {
        self.saving = false
        if (res && res.status === 'ok') {
          if (self.embedded) {
            self.$emit('saved', { openedId: self.openedId, star: self.finalStar })
          } else {
            self.$router.push('/lesson/bookLessonOpenedList')
          }
        }
      }).catch(function () {
        self.saving = false
      })
    }
  }
}
</script>

<style scoped>
.cf-page.is-embed {
  margin: 0;
  max-height: 70vh;
  overflow: auto;
}
.cf-page {
  --primary: #2e6fd1;
  --primary-deep: #1a4d8f;
  --star: #f0a020;
  --ink: #1c2430;
  --ink-2: #4a5566;
  --ink-3: #8a95a6;
  --line: #e3e8f0;
  --bg: #eef2f7;
  --card: #ffffff;
  --red: #c62828;
  --red-bg: #fdeaea;
  --green: #1f8a4c;
  --green-bg: #e7f5ec;
  --warn-bg: #fff6e8;
  --warn-ft: #a86b00;
  box-sizing: border-box;
  margin: -24px;
  border-radius: 8px;
  background: var(--bg);
  color: var(--ink);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  font-size: 15px;
  line-height: 1.7;
  -webkit-tap-highlight-color: transparent;
}
.cf-page * {
  box-sizing: border-box;
}
.cf-app {
  max-width: 680px;
  margin: 0 auto;
  padding: 20px 16px 60px;
}
.rater {
  margin-bottom: 12px;
  font-size: 14px;
  color: var(--ink-2);
}
.card {
  background: var(--card);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(20, 40, 80, .06);
}
.card h2 {
  font-size: 15px;
  color: var(--primary-deep);
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.card h2::before {
  content: "";
  width: 4px;
  height: 16px;
  background: var(--primary);
  border-radius: 2px;
}
.rate {
  background: var(--card);
  border-radius: 16px;
  padding: 26px 20px 22px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(20, 40, 80, .06);
  text-align: center;
}
.rate .q {
  font-size: 15px;
  font-weight: 700;
  color: var(--primary-deep);
}
.rate .sub {
  font-size: 12px;
  color: var(--ink-3);
  margin-bottom: 14px;
}
.bigstars {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.bigstars .s {
  font-size: 52px;
  color: #dfe5ee;
  cursor: pointer;
  line-height: 1;
  transition: transform .12s, color .12s;
  user-select: none;
}
.bigstars .s:hover {
  transform: scale(1.12);
}
.bigstars .s.on {
  color: var(--star);
}
.rate-read {
  margin-top: 10px;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.rate-read .emo {
  font-size: 30px;
}
.rate-read .txt {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary-deep);
}
.rate-read .hint {
  font-size: 12px;
  color: var(--ink-3);
}
.sug {
  display: none;
  text-align: left;
  margin-top: 18px;
  border-top: 1px dashed var(--line);
  padding-top: 16px;
}
.sug.show {
  display: block;
  animation: fade .25s;
}
.sug .cap {
  font-size: 12px;
  color: var(--ink-3);
  margin-bottom: 10px;
}
.sug .cap b {
  color: var(--ink-2);
}
.taglist {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}
.tag {
  border: 1px solid var(--line);
  background: #f2f5fa;
  border-radius: 12px;
  padding: 8px 13px;
  cursor: pointer;
  user-select: none;
  transition: .15s;
  max-width: 100%;
}
.tag:hover {
  border-color: var(--primary);
}
.tag .t {
  font-size: 13.5px;
  color: var(--ink);
}
.tag .d {
  font-size: 10.5px;
  color: var(--ink-3);
  margin-top: 1px;
}
.tag.sel {
  background: var(--primary);
  border-color: var(--primary);
}
.tag.sel .t {
  color: #fff;
  font-weight: 600;
}
.tag.sel .d {
  color: rgba(255, 255, 255, .8);
}
.sugbtns {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}
.mini {
  flex: 1;
  border: 1.5px solid var(--line);
  background: #fff;
  border-radius: 10px;
  padding: 9px;
  font-size: 13px;
  color: var(--ink-2);
  cursor: pointer;
  font-family: inherit;
}
.mini:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.mini.strong {
  background: var(--primary-deep);
  color: #fff;
  border-color: var(--primary-deep);
}
@keyframes fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.lib {
  display: none;
  margin-top: 14px;
  border-top: 1px dashed var(--line);
  padding-top: 14px;
}
.lib.show {
  display: block;
}
.lib .search {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 9px 12px;
  font-size: 14px;
  font-family: inherit;
  margin-bottom: 10px;
  outline: none;
}
.lib .search:focus {
  border-color: var(--primary);
}
.lib .grp {
  margin-bottom: 12px;
}
.lib .grp h4 {
  margin: 0 0 6px;
  font-size: 13px;
  color: var(--primary-deep);
  display: flex;
  align-items: center;
  gap: 6px;
}
.lib .grp h4 .n {
  background: var(--star);
  color: #fff;
  border-radius: 6px;
  padding: 1px 8px;
  font-size: 12px;
}
.lib-empty {
  font-size: 13px;
  color: #8a95a6;
}
.picked {
  display: none;
  background: var(--card);
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(20, 40, 80, .06);
}
.picked.show {
  display: block;
}
.picked .hd {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary-deep);
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.picked .hd span {
  font-size: 12px;
  color: var(--ink-3);
  font-weight: 400;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chip {
  background: var(--green-bg);
  color: var(--green);
  border-radius: 8px;
  padding: 6px 11px;
  font-size: 13px;
}
.chip i {
  font-style: normal;
  color: var(--ink-3);
  font-size: 11px;
}
.conflict {
  margin-top: 10px;
  background: var(--warn-bg);
  color: var(--warn-ft);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12.5px;
}
.redcard {
  background: var(--card);
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(20, 40, 80, .06);
  border: 1.5px solid var(--line);
}
.redcard.on {
  border-color: #e8a3a3;
  background: #fff8f8;
}
.redcard .rt {
  font-size: 15px;
  font-weight: 700;
  color: var(--red);
}
.redcard .rd {
  font-size: 12px;
  color: var(--ink-3);
  margin: 2px 0 4px;
}
.ritem {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #f0c9c9;
  background: #fff;
  border-radius: 10px;
  padding: 8px 12px;
  margin-top: 8px;
  cursor: pointer;
  user-select: none;
  transition: .15s;
}
.ritem:hover {
  border-color: var(--red);
}
.ritem .ck {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid #d5a0a0;
  flex: none;
  position: relative;
  transition: .15s;
}
.ritem .rl-t {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ink);
  flex: none;
}
.ritem .rl-d {
  font-size: 11.5px;
  color: var(--ink-3);
}
.ritem.sel {
  background: var(--red-bg);
  border-color: var(--red);
}
.ritem.sel .ck {
  background: var(--red);
  border-color: var(--red);
}
.ritem.sel .ck::after {
  content: "✓";
  position: absolute;
  color: #fff;
  font-size: 12px;
  left: 2px;
  top: -3px;
}
.ritem.sel .rl-t {
  color: var(--red);
}
.summary {
  background: linear-gradient(135deg, #123a6b, #1a4d8f);
  color: #fff;
  border-radius: 16px;
  padding: 20px;
}
.summary .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.summary .score {
  font-size: 38px;
  font-weight: 700;
}
.summary .score small {
  font-size: 14px;
  font-weight: 400;
  opacity: .8;
}
.summary .big {
  font-size: 24px;
  letter-spacing: 2px;
}
.summary .grade {
  background: rgba(255, 255, 255, .16);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}
.summary .advice {
  font-size: 13px;
  opacity: .92;
  margin-top: 8px;
}
.summary .warn {
  margin-top: 10px;
  background: rgba(198, 40, 40, .9);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
}
.sum-label {
  font-size: 12px;
  opacity: .8;
}
.sum-right {
  text-align: right;
}
.note {
  margin-top: 16px;
}
.note textarea {
  width: 100%;
  min-height: 88px;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  background: #fbfcfe;
  resize: vertical;
  outline: none;
}
.note textarea:focus {
  border-color: var(--primary);
  background: #fff;
}
.note .cnt {
  text-align: right;
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 4px;
}
.save {
  display: block;
  width: 100%;
  border: none;
  background: var(--primary-deep);
  color: #fff;
  border-radius: 12px;
  padding: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
}
.save:hover {
  background: var(--primary);
}
.cf-page.is-lock .bigstars .s,
.cf-page.is-lock .tag,
.cf-page.is-lock .chip,
.cf-page.is-lock .ritem {
  pointer-events: none;
}
.cf-page.is-lock .bigstars .s {
  cursor: default;
}
.cf-page.is-lock .bigstars .s:hover {
  transform: none;
}
@media (max-width: 520px) {
  .bigstars .s {
    font-size: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// ClassFeedback.vue?49d30710